<div class="informations">
    <div
        [ngClass]="{ 'place limiter': last }"
        *ngFor="let hour of session.hours; first as first; last as last"
    >
        <h3>
            <span *ngIf="first">{{ 'session-details.hours' | translate }}</span>
        </h3>
        <span style="width: 25%; margin-left: 20px">
            <span
                >{{ hour.date | date }} : {{ hour.startTime }} -
                {{ hour.endTime }}</span
            >
        </span>
    </div>

    <div
        [ngClass]="{ 'place limiter': last }"
        *ngFor="
            let company of registeredCompanies;
            first as first;
            last as last
        "
    >
        <h3>
            <span *ngIf="first">{{
                'session-details.registrations' | translate
            }}</span>
        </h3>
        <span style="width: 25%; margin-left: 20px">
            <span>{{ 'session-details.company' | translate }} : </span>
            <span class="info-info">{{ company.name }}</span>
            <span class="info-info" *ngIf="company.option">(option)</span>
        </span>
        <span style="width: 50%">
            <span>{{ 'session-details.address' | translate }} : </span>
            <span class="info-info">
                {{ company.address1 }} {{ company.address2 }}
                {{ company.zipCode }} {{ company.city }}
            </span>
        </span>
    </div>

    <div
        [ngClass]="{ 'place limiter': last }"
        *ngFor="let option of registrationOptions; first as first; last as last"
    >
        <h3>
            <span *ngIf="first">{{
                'session-details.registrationOptions' | translate
            }}</span>
        </h3>
        <span style="width: 50%; margin-left: 20px">
            <span>{{ 'session-details.company' | translate }} : </span>
            <span class="info-info">{{ option.companyName }}</span>
        </span>
    </div>

    <div class="place limiter" *ngIf="session.locationType === 'COMPANY'">
        <h3>{{ 'session-details.location' | translate }}</h3>
        <span style="width: 25%; margin-left: 20px">
            <span>{{ 'session-details.company' | translate }} : </span>
            <span class="info-info">{{
                session.company?.name || ('global.to-define' | translate)
            }}</span>
        </span>
        <span style="width: 50%">
            <span>{{ 'session-details.address' | translate }} : </span>
            <span
                class="info-info"
                *ngIf="
                    session.trainingSessionExtended &&
                    session.trainingSessionExtended.address
                "
            >
                {{ session.trainingSessionExtended.address }}
            </span>
            <span
                class="info-info"
                *ngIf="
                    !session.trainingSessionExtended ||
                    !session.trainingSessionExtended.address
                "
            >
                {{
                    session.company
                        ? session.company.address1 +
                          ' ' +
                          session.company.address2 +
                          ' ' +
                          session.company.zipCode +
                          ' ' +
                          session.company.city
                        : ('global.to-define' | translate)
                }}
            </span>
        </span>
    </div>

    <div
        class="place limiter"
        *ngIf="
            session.locationType === 'ZENIKA' ||
            session.locationType === 'PARTNER'
        "
    >
        <h3>{{ 'session-details.location' | translate }}</h3>
        <span style="width: 25%; margin-left: 20px">
            <span>{{ 'session-details.city' | translate }} : </span>
            <span class="info-info">{{ session.location }}</span>
        </span>
        <span style="width: 25%">
            <span>{{ 'session-details.company' | translate }}: </span>
            <span class="info-info">{{ session.local }}</span>
        </span>
        <span style="width: 25%">
            <span>{{ 'session-details.room' | translate }}: </span>
            <span class="info-info">{{ session.room }}</span>
        </span>
    </div>

    <div class="place limiter" *ngIf="session.locationType === 'REMOTE'">
        <h3>{{ 'session-details.location' | translate }}</h3>
        <span style="width: 25%; margin-left: 20px">
            <span>{{ 'session-form.remoteLocation' | translate }}</span>
        </span>
    </div>

    <div class="factu">
        <h3>{{ 'session-details.billing' | translate }}</h3>
        <div style="width: calc(100% - 130px)">
            <span
                style="margin-left: 20px"
                [ngStyle]="{
                    width: billingPlatonIsEnabled ? '25%' : '50%'
                }"
            >
                <span>{{ 'session-details.totalBilling' | translate }}: </span>
                <span class="info-info">{{ displayPrice('total') }}</span>
            </span>
            <div
                style="flex-direction: column"
                [ngStyle]="{ width: billingPlatonIsEnabled ? '25%' : '50%' }"
            >
                <div>
                    <span
                        >{{ 'session-details.otherBilling' | translate }}:
                    </span>
                    <span class="info-info">{{ displayPrice('compl') }}</span>
                </div>
                <div *ngIf="session.billing.expensesType == 'REAL'">
                    {{ 'session-details.realExpenses' | translate }}
                </div>
                <div *ngIf="session.billing.expensesType == 'FIXED'">
                    {{ 'session-details.fixedFee' | translate }}
                </div>
            </div>
            <span *ngIf="billingPlatonIsEnabled" style="width: 25%">
                <span *jhiHasAnyAuthority="['ROLE_BILLING_ADMIN']">
                    <div class="dropup">
                        <button
                            class="btn btn-default dropdown-toggle doc-buttons"
                            type="button"
                            id="menu1"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            [disabled]="billingActionRunning"
                        >
                            Actions
                            <span
                                *ngIf="
                                    !billingActionRunning &&
                                    !billingActionSuccess
                                "
                                class="caret"
                            ></span>
                            <span
                                *ngIf="billingActionRunning"
                                class="fa fa-spinner fa-spin"
                            ></span>
                            <span
                                *ngIf="billingActionSuccess"
                                class="fa fa-check"
                            ></span>
                        </button>
                        <ul
                            class="dropdown-menu multi-level"
                            aria-labelledby="billingActionMenu"
                        >
                            <li
                                class="dropdown-item"
                                *ngIf="billingPlatonIsEnabled"
                            >
                                <button
                                    type="button"
                                    class="btn btn-link"
                                    title="{{
                                        canSendTimesheet()
                                            ? ''
                                            : ('session-details.billing-details.timesheetCompletion'
                                              | translate)
                                    }}"
                                    [disabled]="!canSendTimesheet()"
                                    (click)="saveTrainerTimesheet()"
                                >
                                    {{
                                        'session-details.billing-details.saveTrainerTimesheet'
                                            | translate
                                    }}
                                </button>
                            </li>
                            <li class="dropdown-item">
                                <button
                                    type="button"
                                    class="btn btn-link"
                                    data-toggle="modal"
                                    data-target="#sendBillingReminderToTrainerModal"
                                >
                                    {{
                                        'session-details.billing-details.sendBillingReminderToTrainer'
                                            | translate
                                    }}
                                </button>
                            </li>
                            <li
                                class="dropdown-item"
                                *ngIf="billingPlatonIsEnabled"
                            >
                                <button
                                    type="button"
                                    class="btn btn-link"
                                    (click)="startOrResumeBillingProcess()"
                                >
                                    {{
                                        'session-details.billing-details.startBillingProcess'
                                            | translate
                                    }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </span>
            </span>
            <ng-container *jhiHasAnyAuthority="['ROLE_BILLING_ADMIN']">
                <span *ngIf="billingPlatonIsEnabled && session.timesheetSaved">
                    <i
                        class="fa fa-check"
                        style="color: #308852; font-size: 1.5em"
                    ></i>
                    {{ 'session-list.timesheet' | translate }}
                </span>
            </ng-container>
        </div>
    </div>
    <div>
        <h3></h3>
        <div style="width: calc(100% - 130px)">
            <span style="width: 50%; margin-left: 20px">
                <span>{{ 'session-details.educFees' | translate }}: </span>
                <span class="info-info">{{
                    displayPrice(
                        'fees',
                        session.fees.educFees,
                        session.fees.educFeesCurrency
                    )
                }}</span>
            </span>
            <span style="width: 50%">
                <span>{{ 'session-details.amountsPaid' | translate }}: </span>
                <span class="info-info">{{
                    displayPrice(
                        'fees',
                        session.fees.amountsPaid,
                        session.fees.amountsPaidCurrency
                    )
                }}</span>
            </span>
        </div>
    </div>

    <div class="limiter">
        <h3></h3>
        <div style="width: calc(100% - 130px)">
            <span style="width: 50%; margin-left: 20px">
                <span>{{ 'session-details.lunches' | translate }}: </span>
                <span class="info-info">{{
                    displayPrice(
                        'fees',
                        session.fees.lunches,
                        session.fees.lunchesCurrency
                    )
                }}</span>
            </span>
            <span style="width: 50%">
                <span>{{ 'session-details.roomRental' | translate }}: </span>
                <span class="info-info">{{
                    displayPrice(
                        'fees',
                        session.fees.roomRental,
                        session.fees.roomRentalCurrency
                    )
                }}</span>
            </span>
        </div>
    </div>
    <div
        class="comments limiter"
        *ngIf="session.billing && session.billing.comments"
    >
        <h3>{{ 'session-details.comments' | translate }}</h3>
        <span>
            {{ session.billing.comments }}
        </span>
    </div>
    <div class="limiter" *ngIf="session.training.resources">
        <h3>{{ 'session-details.resources' | translate }}</h3>
        <span>
            {{ session.training.resources }}
        </span>
    </div>
    <div
        class="link limiter"
        *ngIf="
            session.trainingSessionExtended &&
            session.trainingSessionExtended.googleDriveLink
        "
    >
        <h3>Documents</h3>
        <span>
            <a href="{{ session.trainingSessionExtended.googleDriveLink }}">{{
                'session-details.linkToDocuments' | translate
            }}</a>
        </span>
    </div>
    <div class="comments">
        <h3>
            {{ 'session-details.externalSystems.sectionLabel' | translate }}
        </h3>
        <span style="width: 25%">
            <span
                >{{
                    'session-details.externalSystems.zevalAccessId' | translate
                }}:
            </span>
            <span *ngIf="session.zevalAccessId" class="info-info">{{
                session.zevalAccessId
            }}</span>
            <button
                *ngIf="!session.zevalAccessId"
                type="button"
                class="btn btn-link"
                (click)="generateZevalAccessId()"
            >
                {{
                    'session-details.externalSystems.generateZevalAccessId'
                        | translate
                }}
            </button>
        </span>
        <div class="dropup">
            <button
                class="btn btn-default dropdown-toggle doc-buttons"
                type="button"
                id="external-systems-actions-menu"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                [disabled]="externalSystemsActionRunning"
            >
                {{ 'session-details.externalSystems.actions' | translate }}
                <span
                    *ngIf="
                        !externalSystemsActionRunning &&
                        !externalSystemsActionSuccess
                    "
                    class="caret"
                ></span>
                <span
                    *ngIf="externalSystemsActionRunning"
                    class="fa fa-spinner fa-spin"
                ></span>
                <span
                    *ngIf="externalSystemsActionSuccess"
                    class="fa fa-check"
                ></span>
            </button>
            <ul
                class="dropdown-menu multi-level"
                aria-labelledby="externalSystemsActionMenu"
            >
                <li class="dropdown-item">
                    <button
                        type="button"
                        class="btn btn-link"
                        (click)="syncGoogleCalendar()"
                    >
                        {{
                            'session-details.externalSystems.syncGoogleCalendar'
                                | translate
                        }}
                    </button>
                </li>
                <li class="dropdown-item" *jhiHasAnyAuthority="['ROLE_ADMIN']">
                    <button
                        type="button"
                        class="btn btn-link"
                        (click)="syncSignature()"
                        [disabled]="!session.synchronizeSignature"
                    >
                        {{
                            'session-details.externalSystems.syncSignature'
                                | translate
                        }}
                    </button>
                </li>
            </ul>
        </div>
    </div>
</div>

<!-- Modal -->
<div
    class="modal fade"
    id="sendBillingReminderToTrainerModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="sendBillingReminderToTrainerModal"
    aria-hidden="true"
>
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    {{
                        'session-details.billing-details.sendBillingReminderToTrainer'
                            | translate
                    }}
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </h5>
            </div>
            <div class="modal-body">
                <quill-editor
                    [modules]="quillConfig"
                    [(ngModel)]="htmlEmail"
                ></quill-editor>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                >
                    Annuler
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="sendBillingReminderToTrainer()"
                    data-dismiss="modal"
                >
                    Envoyer
                </button>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/description/description.component.html